<sm-title-bar pageTitle="{{ 'business_post.title' | translate }}" [headerCustomTemplate]="addButton" [backWithParams]="true">
<ng-template #addButton>
  <div class="d-flex search-field" style="position: relative;bottom: 15px;">
    <!-- <button mat-button aria-label="option menu" [matMenuTriggerFor]="menu" color="accent" >
      <mat-icon class="material-icons-round try" [inline]="true">add_circle</mat-icon>
    </button> -->
    <div class="create_btn_sd">
      <button mat-icon-button color="accent" (click)="openAddPost()">
          <mat-icon>add</mat-icon> 
      </button>
    </div>
    <div class="" style="position: relative;left: 10px;">
        <button  mat-icon-button  [matMenuTriggerFor]="menu23"  aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu23="matMenu">
            <button mat-menu-item (click)="openpostsetting()">
              <mat-icon>settings</mat-icon>
              <span>Posting setup</span>
            </button>
          </mat-menu>
      </div>
  </div>
</ng-template>
</sm-title-bar>

<div *ngIf="!isLoading && businessPostData.length > 0" class="row">
  <div class="col-sm-6 col-md-6 col-12" *ngFor="let post of businessPostData">
    <sm-admin-post-card
      [postData]="post"
      (onOpenModel)="openModel($event)"
    ></sm-admin-post-card>
  </div>
</div>
<mat-paginator
*ngIf="!isLoading && businessPostData.length > 0"
  class="mt-4"
  [length]="totalData"
  [pageSize]="8"
  (page)="onPageChange($event)"
>
</mat-paginator>


<!-- <ng-container  *ngIf="!isLoading && businessPostData.length == 0">
  <div class="merchant_detail_sec"  >
    <div class="mrt_offer">
      <svg width="150px" height="150px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M23 4C23 2.34315 21.6569 1 20 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4ZM21 4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4Z" fill="#7c7c7c"></path> <path d="M4.80665 17.5211L9.1221 9.60947C9.50112 8.91461 10.4989 8.91461 10.8779 9.60947L14.0465 15.4186L15.1318 13.5194C15.5157 12.8476 16.4843 12.8476 16.8682 13.5194L19.1451 17.5039C19.526 18.1705 19.0446 19 18.2768 19H5.68454C4.92548 19 4.44317 18.1875 4.80665 17.5211Z" fill="#7c7c7c"></path> <path d="M18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8Z" fill="#7c7c7c"></path> </g></svg>
      <h3>
        {{ 'business_post.placeholder_1' | translate }}
      </h3>
    </div>
  </div>   
</ng-container> -->




  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!isLoading && businessPostData.length == 0">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-12">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/open-cvb.png">
                 </div>
                 <mat-card-title>No business post to show
                </mat-card-title>
                 <mat-card-content>Your business haven't started posting feeds in the LookzUp network. You can post updates, promote with offers and make people aware of hip and happenings in your business.
                  
                </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openAddPost()">
                     <mat-icon>add</mat-icon> 
                    Add new
                 </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-12 col-md-12 col-12">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in getting the list of posts or if your customer encountered one while seeing them, contact our support team.



                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 
  <!-- placeholder html end -->